function preventInputNumberScrolling() {
    if (document && document.addEventListener) {
        document.addEventListener(
            "wheel",
            event => {
                if (
                    event.target &&
                    event.target.tagName === "INPUT" &&
                    event.target.type === "number"
                ) {
                    event.preventDefault();
                }
            },
            { passive: false }
        );
    }
}

export default preventInputNumberScrolling;
